<template>
	<q-modal minimized v-model="show_report" no-backdrop-dismiss no-esc-dismiss>
		<q-modal-layout>
			<q-toolbar slot="header">
				<q-btn flat round dense @click="show_report = false" icon="fas fa-times" />
				<q-toolbar-title> {{ trail_id }} - {{ trail_title }} </q-toolbar-title>
			</q-toolbar>

			<div class="layout-padding">
                <q-table
                    ref="table"
                    :data="data"
                    :columns="columns"
                    row-key="id"
                    :pagination.sync="server_pagination"
                    @request="request"
                    :loading="loading"
                    :no-data-label="$t('no_data_avaliable')"
                    :no-results-label="$t('no_results_found')"
                    :loading-label="$t('loading_data')"
                    :rows-per-page-label="$t('items_per_page')"
                    :rows-per-page-options="[5,10,50,100]"
                    binary-state-sort
                    class="q-mt-lg"
                    >

                    <q-tr slot="header" slot-scope="props" :props="props">
                        <q-th v-for="col in props.cols" :key="col.name" :props="props">
                        {{ $t(col.label) }}
                        </q-th>
                    </q-tr>

                    <template slot="body" slot-scope="props">
                        <q-tr :props="props">
                            <q-td key="trail_title" :props="props">
                                {{ props.row.trail_title }}
                            </q-td>

                            <q-td key="trail_content_title" :props="props">
                                {{ props.row.trail_content_title }}
                            </q-td>

                            <q-td key="trail_content_type" :props="props">
                                {{ $t(props.row.trail_content_type) }}
                            </q-td>

                            <q-td key="trail_content_result" :props="props" auto-width>
                                <q-chip small :color="getColorResult(props.row.trail_content_result)" class="full-width">
                                    {{ $t(getResult(props.row.trail_content_result)) }}
                                </q-chip>
                            </q-td>

                            <q-td key="trail_content_status" :props="props" auto-width>
                                <q-chip small  class="full-width" :color="getColorStatus(props.row.trail_content_type, props.row.trail_content_status)">
                                    {{ $t(getStatus(props.row.trail_content_type, props.row.trail_content_status)) }}
                                </q-chip>
                            </q-td>
                        </q-tr>
                    </template>
                </q-table>
            </div>
		</q-modal-layout>
	</q-modal>
</template>

<script>
import { mapGetters } from 'vuex'
import statusHandler from '../../../../../utils/statusHandler'

export default {
	name: 'ContentModal',

    i18nOptions: { namespaces: ['custom', 'common', 'users', 'feed', 'webcast', 'courses', 'games', 'training', 'trails', 'presential', 'admin','podcasts', 'courses'] },

	props: ['show_trail_contents', 'trail_title', 'trail_id'],

	data() {
		return {
			loading: false,
			server_pagination: {
				page: 1,
				rowsNumber: 10,
				rowsPerPage: null,
				descending: false,
				sortBy: null,
			},
            columns: [
                {
                    name: 'trail_title',
                    required: true,
                    label: 'trail',
                    align: 'left',
                    field: 'trail_title',
                    sortable: false,
                },
                {
                    name: 'trail_content_title',
                    required: true,
                    label: 'training',
                    align: 'left',
                    field: 'trail_content_title',
                    sortable: false,
                },
                {
                    name: 'trail_content_type',
                    required: true,
                    label: 'content_type',
                    align: 'left',
                    field: 'trail_content_type',
                    sortable: false,
                },
                {
                    name: 'trail_content_result',
                    required: true,
                    label: 'result',
                    align: 'left',
                    field: 'trail_content_result',
                    sortable: false,
                },
                {
                    name: 'trail_content_status',
                    required: true,
                    label: 'status',
                    align: 'left',
                    field: 'trail_content_status',
                    sortable: false,
                }
            ],
            data: [],
		}
	},

    mixins: [statusHandler],

	computed: {
		...mapGetters({
			access_token: 'common/access_token',
			selected_user: 'users/selected_user',
			num_rows: 'datatable/num_rows',
		}),

		getHeader() {
			let headers = {}
			return (headers = {
				headers: {
					'content-type': 'application/json',
					authorization: 'Basic ' + btoa(process.env.APP_CLIENT_ID + ':' + process.env.APP_CLIENT_SECRET),
					authorization: 'Bearer ' + this.access_token,
				},
			})
		},

		show_report: {
			get() {
				return this.show_trail_contents
			},
			set() {
				this.$emit('hide_report', '')
			},
		},
	},

	methods: {
		request({ pagination }) {
			this.loading = true
			this.server_pagination = pagination

			let order = pagination.descending ? '-' : ''
			let order_by = pagination.sortBy ? order + pagination.sortBy : ''

			let data = {
				page_size: this.server_pagination.rowsPerPage,
				page: this.server_pagination.page,
				ordering: order_by,
			}

			this.savePagination()

			this.$axios.get( `/admin_users/users/${this.selected_user}/get_user_trail_contents_user_results/?trail_id=${this.trail_id}&${this.$qs.stringify(data)}`,this.getHeader
				)
				.then((response) => {
					this.server_pagination.rowsNumber = response.data.count
					 this.data = []

					response.data.results.forEach((result) => {
					 	this.data.push(result)
					})

					this.loading = false
				})
				.catch((e) => {
					this.loading = false
					console.log(e)
				})
		},

        savePagination() {
			this.$store.dispatch('datatable/SET_NUM_ROWS', [this.server_pagination.rowsPerPage])
		},

        loadPagination() {
			this.server_pagination.rowsPerPage = this.num_rows
		},

        getResult(result) {
            if (result == 1) return 'approved'
            else if (result == 2) return 'reproved'
            else if (result == 3) return 'restarted'
            else return ''
        },

        getColorResult(result) {
            if (result == 1) return 'positive'
            else if (result == 2) return 'negative'
            else if (result == 3) return 'warning'
            else return ''
        },
	},

        watch: {
        num_rows: {
            handler (newValue) {
                this.loadPagination()
            },
            deep: true
        }
    },

    created() {
        this.loadPagination()
        this.request({pagination: this.server_pagination})
    }
}
</script>

<style></style>